/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationstatuspending2Inputs */

const en_moderationstatuspending2 = /** @type {(inputs: Moderationstatuspending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const de_moderationstatuspending2 = /** @type {(inputs: Moderationstatuspending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offen`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Moderationstatuspending2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationstatuspending2 = /** @type {((inputs?: Moderationstatuspending2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationstatuspending2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationstatuspending2(inputs)
	return de_moderationstatuspending2(inputs)
});
export { moderationstatuspending2 as "moderationStatusPending" }